/** Query param appended after deskless signup to route first login to add-recovery-method. */
export const FIRST_LOGIN_QUERY_PARAM = 'firstLogin'

export const FIRST_LOGIN_QUERY_VALUE = 'true'

/** True when the URL includes the deskless post-signup `firstLogin` flag. */
export const hasFirstLoginParam = (searchParams: URLSearchParams): boolean =>
  searchParams.get(FIRST_LOGIN_QUERY_PARAM) === FIRST_LOGIN_QUERY_VALUE
